import type { SVGProps } from 'react';
import * as React from 'react';

const UserIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="solid/user">
      <g id="Icon">
        <path
          d="M12 9.60039C13.9882 9.60039 15.6 7.98862 15.6 6.00039C15.6 4.01217 13.9882 2.40039 12 2.40039C10.0117 2.40039 8.39998 4.01217 8.39998 6.00039C8.39998 7.98862 10.0117 9.60039 12 9.60039Z"
          fill="currentColor"
        />
        <path
          d="M4.15818 17.3926C3.92432 18.0023 4.13319 18.6856 4.64901 19.0859C6.67984 20.662 9.2304 21.6004 12.0001 21.6004C14.7727 21.6004 17.3256 20.6601 19.3574 19.0811C19.873 18.6804 20.0814 17.997 19.8471 17.3875C18.6361 14.2366 15.581 12.0004 12.0037 12.0004C8.42435 12.0004 5.36793 14.2391 4.15818 17.3926Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);
export default UserIcon;
